import { Box, Grid, GridItem, Heading, Link, ListItem, OrderedList, Text, VStack } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { FAQS_BTFDCA, FAQS_INVESTORS, FAQS_SUPERFLUID, FAQS_SECURITY, FAQS_CONTACT, FAQS_HELP } from "../config/faqs";

function FaqItem({ id, question, answer, selected }) {
  const [collapsed, setCollapsed] = useState(true);
  const [highlight, setHighlight] = useState(false);

  useEffect(() => {
    if (selected === "#" + id) {
      setHighlight(true);
      setCollapsed(false);
    }
  }, [selected, id]);

  return (
    <ListItem mb="1em" id={id} bg={!collapsed && highlight ? "yellow" : ""}>
      <Box>
        <Text display="inline" onClick={() => setCollapsed(!collapsed)} cursor="pointer" fontWeight="bold">
          {question}
        </Text>
        &nbsp;
        <Text display="inline" onClick={() => setCollapsed(!collapsed)} cursor="pointer" fontSize="xs">
          [{collapsed ? "expand" : "collapse"}]
        </Text>
        &nbsp;
        <Link
          display="inline"
          onClick={(evt) => {
            navigator.clipboard.writeText(window.location.host + "/faq#" + id);
            evt.preventDefault();
          }}
          cursor="pointer"
          fontSize="xs"
          href={"/faq#" + id}
        >
          [copy link to clipboard]
        </Link>
      </Box>
      {collapsed ? <></> : <Text>{answer}</Text>}
    </ListItem>
  );
}

function FaqList({ title, faqs, selected }) {
  return (
    <GridItem>
      {title && (
        <Heading fontSize="2xl" mb="0.5em">
          {title}
        </Heading>
      )}
      <OrderedList>
        {faqs.map((faq) => {
          return <FaqItem id={faq.id} key={faq.id} question={faq.question} answer={faq.answer} selected={selected} />;
        })}
      </OrderedList>
    </GridItem>
  );
}

export default function FAQ() {
  let location = useLocation();

  return (
    <VStack p="2em">
      <Heading mb="0.5em">Frequently "Answered" Questions</Heading>
      <Link
        href="mailto:help@btfdca.finance?subject=Question&body=<replace this with your question>"
        my="1em"
        fontWeight="light"
      >
        Got a question that's not here?
      </Link>

      <Grid w="100%" templateColumns={{ base: "repeat(1, 1fr)", md: "repeat(2, 1fr)" }} gap={8} py="2.5em">
        <FaqList title="About BTFDCA" faqs={FAQS_BTFDCA} selected={location.hash} />
        <FaqList title="Money Streams" faqs={FAQS_SUPERFLUID} selected={location.hash} />
        <FaqList title="For Investors" faqs={FAQS_INVESTORS} selected={location.hash} />
        <FaqList title="Security" faqs={FAQS_SECURITY} selected={location.hash} />
        <FaqList title="Contact" faqs={FAQS_CONTACT} selected={location.hash} />
        <FaqList title="Help" faqs={FAQS_HELP} selected={location.hash} />
      </Grid>
    </VStack>
  );
}
